(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fortunee-service-product"] && !Shopify.designMode) return;
  try {
    
  (async () => {
    document.querySelectorAll('[data-ft-booking-card]').forEach(card => {
      const headerElements = [...document.querySelectorAll('header, sticky-header, .shopify-section-group-header-group')];
      let frame = 0;
      const updateCardPosition = () => {
        frame = 0;
        let headerBottom = 0;
        headerElements.forEach(header => {
          const rect = header.getBoundingClientRect();
          if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;
          let ancestor = header;
          while (ancestor && ancestor !== document.body) {
            const position = getComputedStyle(ancestor).position;
            if (position === 'sticky' || position === 'fixed') {
              headerBottom = Math.max(headerBottom, rect.bottom);
              break;
            }
            ancestor = ancestor.parentElement;
          }
        });
        card.style.setProperty('--ft-card-height', `${card.getBoundingClientRect().height}px`);
        card.style.setProperty('--ft-header-bottom', `${headerBottom}px`);
      };
      const scheduleCardPosition = () => {
        if (!frame) frame = requestAnimationFrame(updateCardPosition);
      };
      updateCardPosition();
      const cardSizeObserver = new ResizeObserver(scheduleCardPosition);
      cardSizeObserver.observe(card);
      headerElements.forEach(header => cardSizeObserver.observe(header));
      window.addEventListener('resize', scheduleCardPosition, { passive: true });
      window.addEventListener('scroll', scheduleCardPosition, { passive: true });
    });
    const source = document.querySelector('[data-ft-service]');
    if (!source) return;
    const loadScript = (url) => new Promise((resolve, reject) => {
      const script = document.createElement('script'); script.src = url;
      script.onload = resolve; script.onerror = reject; document.head.append(script);
    });
    try {
      await Promise.all([
        window.flatpickr ? Promise.resolve() : loadScript(source.dataset.pickerJs),
        window.libphonenumber ? Promise.resolve() : loadScript(source.dataset.phoneJs)
      ]);
    } catch (error) {
      source.querySelectorAll('[data-ft-open-booking], [data-ft-open-urgent]').forEach(button => {
        button.addEventListener('click', () => window.alert(source.dataset.apiPending));
      });
      return;
    }
    const pad = (value) => String(value).padStart(2, '0');
    const formatLocalDate = (date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

    document.querySelectorAll('[data-ft-service]').forEach((root) => {
      if (root.dataset.ftReady === 'true') return;
      root.dataset.ftReady = 'true';

      const bookingDialog = root.querySelector('[data-ft-booking-dialog]');
      const urgentDialog = root.querySelector('[data-ft-urgent-dialog]');
      const urgentForm = root.querySelector('[data-ft-urgent-form]');
      const urgentSubmit = root.querySelector('[data-ft-urgent-submit]');
      const urgentStatus = root.querySelector('[data-ft-urgent-status]');
      const urgentFields = root.querySelector('[data-ft-urgent-fields]');
      const urgentDob = root.querySelector('[data-ft-urgent-dob]');
      let urgentWaiting = false;
      let urgentFinished = false;
      let urgentTimer;
      let urgentRequestId = '';
      const urgentMessage = (text) => { urgentStatus.hidden = false; urgentStatus.textContent = text; };
      const newUrgentId = () => {
        const bytes = crypto.getRandomValues(new Uint8Array(16));
        bytes[6] = (bytes[6] & 15) | 64;
        bytes[8] = (bytes[8] & 63) | 128;
        const hex = Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
        return `${hex.slice(0,8)}-${hex.slice(8,12)}-${hex.slice(12,16)}-${hex.slice(16,20)}-${hex.slice(20)}`;
      };
      let urgentConfigured = false;
      try {
        const endpoint = new URL(urgentForm.getAttribute('action'));
        urgentConfigured = endpoint.origin === 'https://script.google.com' && /^\/macros\/s\/[^/]+\/exec$/.test(endpoint.pathname);
      } catch (error) { urgentConfigured = false; }
      urgentSubmit.disabled = !urgentConfigured;
      if (!urgentConfigured) urgentMessage(urgentForm.dataset.unavailable);
      urgentDob.addEventListener('input', () => urgentDob.setCustomValidity(''));
      root.querySelector('[data-ft-urgent-unknown]').addEventListener('change', event => {
        const input = urgentForm.elements.birthTimeDisplay;
        if (event.target.checked) {
          input._flatpickr.clear();
          input._flatpickr.close();
          urgentForm.elements.birthTime.value = '';
        }
        input.disabled = event.target.checked;
        urgentForm.elements.birthTime.disabled = event.target.checked;
      });
      urgentForm.addEventListener('submit', event => {
        event.preventDefault();
        if (!urgentConfigured || urgentWaiting || urgentFinished) return;
        const value = urgentDob.value.trim();
        let iso = '';
        if (value) {
          const parts = value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
          if (parts) iso = `${parts[3]}-${parts[2]}-${parts[1]}`;
          const date = iso ? new Date(`${iso}T00:00:00Z`) : new Date(NaN);
          if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0,10) !== iso) {
            urgentDob.setCustomValidity(urgentForm.dataset.invalidDate);
            urgentFields.inert = false;
            urgentDob.reportValidity();
            return;
          }
        }
        urgentForm.elements.dob.value = iso;
        if (!urgentForm.elements.preferredTime.value) { urgentForm.elements.preferredTime.focus(); urgentMessage(urgentForm.dataset.invalidDate); return; }
        if (!urgentForm.reportValidity()) return;
        urgentRequestId ||= newUrgentId();
        urgentForm.elements.requestId.value = urgentRequestId;
        urgentWaiting = true;
        urgentSubmit.disabled = true;
        urgentForm.setAttribute('aria-busy', 'true');
        urgentFields.inert = true;
        urgentMessage(urgentForm.dataset.pending);
        clearTimeout(urgentTimer);
        urgentTimer = setTimeout(() => {
          urgentWaiting = false;
          urgentSubmit.disabled = false;
          urgentSubmit.textContent = urgentForm.dataset.retry;
          urgentForm.setAttribute('aria-busy', 'false');
          urgentMessage(urgentForm.dataset.timeout);
        }, 45000);
        HTMLFormElement.prototype.submit.call(urgentForm);
      });
      window.addEventListener('message', event => {
        if (!root.isConnected || !urgentRequestId || urgentFinished) return;
        let hostname;
        try { const origin = new URL(event.origin); if (origin.protocol !== 'https:') return; hostname = origin.hostname; } catch (error) { return; }
        if (!(hostname === 'script.google.com' || hostname === 'script.googleusercontent.com' || hostname.endsWith('-script.googleusercontent.com'))) return;
        const result = event.data;
        if (!result || result.type !== 'fortunee:urgent-result' || result.requestId !== urgentRequestId || typeof result.ok !== 'boolean') return;
        clearTimeout(urgentTimer);
        urgentWaiting = false;
        urgentForm.setAttribute('aria-busy', 'false');
        if (result.ok) {
          urgentFinished = true;
          urgentSubmit.disabled = true;
          urgentMessage(urgentForm.dataset.success);
        } else {
          urgentFields.inert = false;
          urgentSubmit.disabled = false;
          urgentSubmit.textContent = urgentForm.dataset.retry;
          urgentMessage(typeof result.message === 'string' ? result.message : urgentForm.dataset.timeout);
        }
      });
      const card = root.querySelector('[data-ft-booking-card]');
      const sticky = root.querySelector('[data-ft-sticky-booking]');
      const form = root.querySelector('[data-ft-booking-form]');
      const stepOne = root.querySelector('[data-ft-step="1"]');
      const stepTwo = root.querySelector('[data-ft-step="2"]');
      // const stepThree = root.querySelector('[data-ft-step="3"]');
      const reviewMessage = root.querySelector('[data-ft-review-message]');
      const progress = root.querySelectorAll('[data-ft-progress]');
      let appointmentPicker;
      const slotGrid = root.querySelector('[data-ft-slots]');
      const message = root.querySelector('[data-ft-booking-message]');
      const selectedInput = root.querySelector('[data-ft-appointment-start]');
      const selectedSummary = root.querySelector('[data-ft-booking-summary]');
      const selectedLabel = root.querySelector('[data-ft-selected-slot]');
      const submitButton = root.querySelector('[data-ft-booking-submit]');
      const timezoneLabel = root.querySelector('[data-ft-timezone]');
      const detectedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'Asia/Kolkata';
      const timezone = detectedTimezone === 'Asia/Calcutta' ? 'Asia/Kolkata' : detectedTimezone;
      const apiUrl = root.dataset.apiUrl.replace(/\/$/, '');
      const minNotice = Number(root.dataset.minNotice || 24);
      const minDateTime = new Date(Date.now() + minNotice * 60 * 60 * 1000);
      const minDate = new Date(minDateTime.getFullYear(), minDateTime.getMonth(), minDateTime.getDate());
      let selectedDate = null;
      let selectedStart = '';
      let availabilityRequest = 0;

      timezoneLabel.textContent = timezone;

      const updateSticky = () => {
        const visible = card.getBoundingClientRect().bottom <= 0 && !bookingDialog.open && !urgentDialog.open;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', String(!visible));
        sticky.inert = !visible;
      };
      const setDialogState = (open) => {
        root.classList.toggle('has-open-dialog', open);
        updateSticky();
      };

      root.querySelectorAll('[data-ft-open-booking]').forEach((button) => {
        button.addEventListener('click', () => {
          bookingDialog.showModal();
          setDialogState(true);
        });
      });

      root.querySelectorAll('[data-ft-open-urgent]').forEach((button) => {
        button.addEventListener('click', () => {
          urgentDialog.showModal();
          setDialogState(true);
        });
      });

      root.querySelectorAll('[data-ft-close-dialog]').forEach((button) => {
        button.addEventListener('click', () => button.closest('dialog').close());
      });

      [bookingDialog, urgentDialog].forEach((dialog) => {
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
        dialog.addEventListener('close', () => setDialogState(false));
      });

      const observer = new IntersectionObserver(updateSticky, {threshold: [0, 1]});
      observer.observe(card);
      window.addEventListener('scroll', updateSticky, {passive:true});
      updateSticky();

      const unknownTime = form.querySelector('[data-ft-time-unknown]');
      unknownTime.addEventListener('change', () => {
        form.querySelectorAll('[name="birthTimeDisplay"]').forEach((input) => {
          input.disabled = unknownTime.checked;
          input.required = !unknownTime.checked;
        });
      });

      const renderSlots = (slots) => {
        slotGrid.replaceChildren();
        selectedStart = '';
        selectedInput.value = '';
        selectedSummary.hidden = true;
        submitButton.disabled = true;

        if (!slots.length) {
          message.textContent = root.dataset.slotError;
          return;
        }

        message.textContent = slots.some(slot => typeof slot === 'string' || slot.available !== false) ? '' : root.dataset.slotError;
        slots.forEach((slot) => {
          const start = typeof slot === 'string' ? slot : slot.start;
          const startDate = new Date(start);
          const labelText = typeof slot === 'string' || !slot.label
            ? new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit' }).format(startDate)
            : slot.label;
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'ft-slot';
          const unavailable = typeof slot !== 'string' && slot.available === false;
          button.disabled = unavailable;
          button.textContent = labelText;
          if (unavailable) {
            const status = document.createElement('span');
            status.className = 'ft-slot__status';
            status.textContent = slot.status === 'booked' ? root.dataset.slotBooked : root.dataset.slotUnavailable;
            button.append(status);
            button.setAttribute('aria-label', `${labelText} — ${status.textContent}`);
          }
          button.addEventListener('click', () => {
            if (button.disabled) return;
            slotGrid.querySelectorAll('.ft-slot').forEach((item) => item.classList.remove('is-selected'));
            button.classList.add('is-selected');
            selectedStart = start;
            selectedInput.value = start;
            selectedLabel.textContent = new Intl.DateTimeFormat('en-US', { dateStyle: 'full', timeStyle: 'short' }).format(startDate);
            selectedSummary.hidden = false;
            submitButton.disabled = false;
          });
          slotGrid.append(button);
        });
      };

      const demoSlots = (date) => ['10:00', '11:30', '13:00', '15:30', '17:00'].map((time) => {
        const [hour, minute] = time.split(':').map(Number);
        const slot = new Date(date.getFullYear(), date.getMonth(), date.getDate(), hour, minute);
        return slot.toISOString();
      }).filter((slot) => new Date(slot) >= minDateTime);

      const selectDate = async (date) => {
        selectedDate = date;
        const request = ++availabilityRequest;
        selectedStart = ''; selectedInput.value = ''; selectedSummary.hidden = true; submitButton.disabled = true;
        message.textContent = root.dataset.loading;
        slotGrid.replaceChildren();

        if (!apiUrl) {
          if (root.dataset.demoSlots === 'true') {
            renderSlots(demoSlots(date));
          } else {
            message.textContent = root.dataset.apiPending;
          }
          return;
        }

        try {
          const params = new URLSearchParams({
            productId: root.dataset.productId,
            duration: root.dataset.duration,
            date: formatLocalDate(date),
            timezone
          });
          const response = await fetch(`${apiUrl}/availability?${params.toString()}`, { headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('availability');
          const data = await response.json();
          if (request !== availabilityRequest) return;
          renderSlots(Array.isArray(data.slotOptions) ? data.slotOptions : Array.isArray(data.slots) ? data.slots : []);
        } catch (error) {
          if (request !== availabilityRequest) return;
          message.textContent = root.dataset.slotError;
        }
      };

      appointmentPicker = window.flatpickr(root.querySelector('[data-ft-appointment-date]'), {
        inline: true, disableMobile: true, dateFormat: 'Y-m-d', minDate,
        onChange: dates => { if (dates[0]) selectDate(dates[0]); }
      });
      const dobPicker = window.flatpickr(form.elements.birthDateDisplay, {
        disableMobile: true, static: true, dateFormat: 'd/m/Y', maxDate: 'today',
        onChange: dates => {
          const d = dates[0];
          form.elements.birthDay.value = d ? d.getDate() : '';
          form.elements.birthMonth.value = d ? d.getMonth() + 1 : '';
          form.elements.birthYear.value = d ? d.getFullYear() : '';
        }
      });
      window.flatpickr(form.elements.birthTimeDisplay, {
        disableMobile: true, static: true, enableTime: true, noCalendar: true,
        dateFormat: 'h:i K', time_24hr: false, minuteIncrement: 1,
        onChange: dates => {
          const d = dates[0];
          form.elements.birthHour.value = d ? d.getHours() % 12 || 12 : '';
          form.elements.birthMinute.value = d ? pad(d.getMinutes()) : '';
          form.elements.birthPeriod.value = d ? (d.getHours() >= 12 ? 'PM' : 'AM') : '';
        }
      });
      window.flatpickr(urgentDob, {disableMobile:true, static:true, dateFormat:'d/m/Y', maxDate:'today'});
      window.flatpickr(urgentForm.elements.birthTimeDisplay, {
        disableMobile: true, static: true, enableTime: true, noCalendar: true,
        dateFormat: 'h:i K', time_24hr: false, minuteIncrement: 1,
        onChange: dates => {
          const d = dates[0];
          urgentForm.elements.birthTime.value = d ? `${pad(d.getHours())}:${pad(d.getMinutes())}` : '';
        }
      });
      window.flatpickr(urgentForm.elements.preferredTime, {disableMobile:true, static:true, enableTime:true, dateFormat:'d/m/Y H:i', altInput:true, altFormat:'d/m/Y h:i K', time_24hr:false, minDate:'today', minuteIncrement:15});
      const validateContact = target => {
        const email = target.elements.email;
        const phone = target.elements.phone;
        email.value = email.value.trim();
        email.setCustomValidity(/^[^\s@]+@[^\s@.]+(?:\.[^\s@.]+)+$/.test(email.value) ? '' : root.dataset.invalidEmail);
        const parsed = window.libphonenumber.parsePhoneNumberFromString(phone.value.trim(), 'IN');
        phone.setCustomValidity(/^[0-9]{1,10}$/.test(phone.value) && parsed && parsed.isValid() ? '' : root.dataset.invalidPhone);
        return email.checkValidity() && phone.checkValidity();
      };
      [form, urgentForm].forEach(target => {
        const phone = target.elements.phone;
        phone.addEventListener('input', () => {
          phone.value = phone.value.replace(/[^0-9]/g, '').slice(0, 10);
          phone.setCustomValidity('');
        });
        ['email', 'phone'].forEach(name => {
          target.elements[name].addEventListener('input', () => target.elements[name].setCustomValidity(''));
          target.elements[name].addEventListener('blur', () => validateContact(target));
        });
        target.addEventListener('submit', event => {
          if (!validateContact(target)) { event.preventDefault(); event.stopImmediatePropagation(); target.reportValidity(); }
        }, true);
      });
      root.querySelector('[data-ft-next-step]').addEventListener('click', () => {
        validateContact(form);
        if (!form.elements.birthDay.value || (!unknownTime.checked && !form.elements.birthHour.value)) {
          form.elements.birthDateDisplay.focus(); window.alert(root.dataset.missingBirth); return;
        }
        const fields = [...stepOne.querySelectorAll('input, select, textarea')].filter((field) => !field.disabled);
        const firstInvalid = fields.find((field) => !field.checkValidity());
        if (firstInvalid) {
          firstInvalid.reportValidity();
          return;
        }
        stepOne.hidden = true;
        stepTwo.hidden = false;
        progress[0].classList.remove('is-active');
        progress[1].classList.add('is-active');
        if (!selectedDate) { appointmentPicker.setDate(minDate); selectDate(minDate); }
      });

      root.querySelector('[data-ft-previous-step]').addEventListener('click', () => {
        stepTwo.hidden = true;
        stepOne.hidden = false;
        progress[1].classList.remove('is-active');
        progress[0].classList.add('is-active');
      });

      // root.querySelector('[data-ft-review]').addEventListener('click', () => {
      //   if (!selectedStart) { message.textContent = root.dataset.slotError; return; }
      //   const details = new FormData(form);
      //   root.querySelector('[data-ft-review-summary]').textContent = `${selectedLabel.textContent} (${timezone}) — ${details.get('fullName')} · ${details.get('email')} · ${details.get('phone')}`;
      //   stepTwo.hidden = true; stepThree.hidden = false;
      //   progress[1].classList.remove('is-active'); progress[2].classList.add('is-active');
      // });
      // root.querySelector('[data-ft-edit]').addEventListener('click', () => {
      //   stepThree.hidden = true; stepOne.hidden = false;
      //   progress[2].classList.remove('is-active'); progress[0].classList.add('is-active');
      // });
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!selectedStart) return;
        if (root.dataset.checkoutEnabled !== 'true') {
          reviewMessage.textContent = root.dataset.previewNotice;
          return;
        }
        if (!apiUrl) {
          message.textContent = root.dataset.apiPending;
          return;
        }

        submitButton.disabled = true;
        const originalText = submitButton.textContent;
        submitButton.textContent = root.dataset.loading;

        try {
          const details = Object.fromEntries(new FormData(form).entries());
          details.productId = root.dataset.productId;
          details.variantId = root.dataset.variantId;
          details.duration = Number(root.dataset.duration);
          details.timezone = timezone;

          const holdResponse = await fetch(`${apiUrl}/holds`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(details)
          });
          const hold = await holdResponse.json();
          if (!holdResponse.ok) {
            if (hold.error === 'slot_unavailable') {
              stepTwo.hidden = false;
              stepOne.hidden = true;
              progress[0].classList.remove('is-active');
              progress[1].classList.add('is-active');
              await selectDate(selectedDate);
              message.textContent = root.dataset.slotTaken;
              message.setAttribute('role', 'status');
              message.setAttribute('tabindex', '-1');
              message.focus();
              return;
            }
            throw new Error('hold');
          }
          if (!hold.token) throw new Error('token');

          const appointmentLabel = new Intl.DateTimeFormat('en-US', { dateStyle: 'full', timeStyle: 'short' }).format(new Date(selectedStart));
          const cartResponse = await fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{
                id: Number(root.dataset.variantId.split('/').pop()),
                quantity: 1,
                properties: {
                  Appointment: appointmentLabel,
                  'Consultation duration': `${root.dataset.duration} minutes`,
                  _booking_hold: hold.token
                }
              }]
            })
          });
          if (!cartResponse.ok) throw new Error('cart');
          window.location.assign('/checkout');
        } catch (error) {
          reviewMessage.textContent = root.dataset.submitError;
          submitButton.disabled = false;
          submitButton.textContent = originalText;
        } finally {
          submitButton.textContent = originalText;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
